import script from "./SolutionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SolutionView.vue?vue&type=script&lang=ts&setup=true"

import "./SolutionView.vue?vue&type=style&index=0&id=5b1d32e0&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b1d32e0"]])

export default __exports__